// TODO variable region, such as en-GB or fr-FR

import { CurrencyEnum } from '../../types/Currency'
import { PayoutCryptoCurrency, PayoutCurrency } from '../../types/Payout'

export const formatCurrency = (
  num: number,
  digitAfterDecimalPoint = 0,
  decimals: number = 0,
  currency: CurrencyEnum | PayoutCurrency,
  locale: string = 'en-US',
): string => {
  const numericNum = Number(num)
  if (currency === PayoutCryptoCurrency.EURC) {
    currency = CurrencyEnum.EUR
  }
  const isCryptoCurrency = Object.values(PayoutCryptoCurrency).includes(
    currency as PayoutCryptoCurrency,
  )

  const adjustedNum = numericNum / 10 ** decimals
  let flooredNum = adjustedNum

  if (Number.isInteger(numericNum) && decimals > 0) {
    if (decimals >= digitAfterDecimalPoint) {
      const truncateFactor = 10 ** (decimals - digitAfterDecimalPoint)
      flooredNum =
        Math.trunc(numericNum / truncateFactor) / 10 ** digitAfterDecimalPoint
    }
  } else {
    const factor = 10 ** digitAfterDecimalPoint
    flooredNum = Math.trunc(adjustedNum * factor) / factor
  }

  if (isCryptoCurrency) {
    const formatterCrypto = new Intl.NumberFormat(locale, {
      minimumFractionDigits: digitAfterDecimalPoint,
      maximumFractionDigits: digitAfterDecimalPoint,
    })

    const formattedNumber = formatterCrypto.format(flooredNum)
    return `${formattedNumber} ${currency}`
  } else {
    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: digitAfterDecimalPoint,
      maximumFractionDigits: digitAfterDecimalPoint,
    })

    return formatter.format(flooredNum)
  }
}

export const formatPrice = (price: number): number => {
  return Math.round((price / 100) * 100) / 100
}

export const formatNumber = (
  num: number,
  digitAfterDecimalPoint = 0,
  decimals: number = 0,
): string => {
  const adjustedNum = num / 10 ** decimals

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: digitAfterDecimalPoint,
    maximumFractionDigits: digitAfterDecimalPoint,
  })

  return formatter.format(adjustedNum)
}

export const formatPercentage = (
  num: number,
  digitAfterDecimalPoint = 1,
  divideHundred: boolean,
): string => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: digitAfterDecimalPoint,
  })

  const fractionalNumber = num / 100

  return formatter.format(
    divideHundred ? fractionalNumber / 100 : fractionalNumber,
  )
}

export const toCents = (v: number) =>
  Math.round(parseFloat((v * 100).toFixed(2)))
